// Medianoche del 6 de noviembre de 2026 en Caracas (UTC-4, sin horario de verano).
export const BETA_START_AT = new Date('2026-11-06T00:00:00-04:00')

const MS_PER_MINUTE = 60_000
const MS_PER_HOUR = 60 * MS_PER_MINUTE
const MS_PER_DAY = 24 * MS_PER_HOUR

export interface BetaCountdown {
  days: number
  hours: number
  minutes: number
}

/** Tiempo restante hasta el inicio de la beta; `null` cuando ya empezó. */
export function computeBetaCountdown(now: Date, target: Date = BETA_START_AT): BetaCountdown | null {
  const remaining = target.getTime() - now.getTime()
  if (remaining <= 0) return null
  return {
    days: Math.floor(remaining / MS_PER_DAY),
    hours: Math.floor((remaining % MS_PER_DAY) / MS_PER_HOUR),
    minutes: Math.floor((remaining % MS_PER_HOUR) / MS_PER_MINUTE),
  }
}
